export const COUNTRY_LIST = [
    // Популярные (в начале списка)
    { key: 'montenegro', code: 'me', labelId: 'Country.montenegro' },
    { key: 'france', code: 'fr', labelId: 'Country.france' },
    { key: 'russia', code: 'ru', labelId: 'Country.russia' },
    { key: 'serbia', code: 'rs', labelId: 'Country.serbia' },
    
    // СНГ и соседи
    { key: 'armenia', code: 'am', labelId: 'Country.armenia' },
    { key: 'azerbaijan', code: 'az', labelId: 'Country.azerbaijan' },
    { key: 'belarus', code: 'by', labelId: 'Country.belarus' },
    { key: 'georgia', code: 'ge', labelId: 'Country.georgia' },
    { key: 'kazakhstan', code: 'kz', labelId: 'Country.kazakhstan' },
    { key: 'kyrgyzstan', code: 'kg', labelId: 'Country.kyrgyzstan' },
    { key: 'moldova', code: 'md', labelId: 'Country.moldova' },
    { key: 'ukraine', code: 'ua', labelId: 'Country.ukraine' },
    { key: 'tajikistan', code: 'tj', labelId: 'Country.tajikistan' },
    { key: 'turkmenistan', code: 'tm', labelId: 'Country.turkmenistan' },
    { key: 'uzbekistan', code: 'uz', labelId: 'Country.uzbekistan' },
  
    // Евросоюз
    { key: 'austria', code: 'at', labelId: 'Country.austria' },
    { key: 'belgium', code: 'be', labelId: 'Country.belgium' },
    { key: 'bulgaria', code: 'bg', labelId: 'Country.bulgaria' },
    { key: 'croatia', code: 'hr', labelId: 'Country.croatia' },
    { key: 'cyprus', code: 'cy', labelId: 'Country.cyprus' },
    { key: 'czech_republic', code: 'cz', labelId: 'Country.czech_republic' },
    { key: 'denmark', code: 'dk', labelId: 'Country.denmark' },
    { key: 'estonia', code: 'ee', labelId: 'Country.estonia' },
    { key: 'finland', code: 'fi', labelId: 'Country.finland' },
    { key: 'germany', code: 'de', labelId: 'Country.germany' },
    { key: 'greece', code: 'gr', labelId: 'Country.greece' },
    { key: 'hungary', code: 'hu', labelId: 'Country.hungary' },
    { key: 'ireland', code: 'ie', labelId: 'Country.ireland' },
    { key: 'italy', code: 'it', labelId: 'Country.italy' },
    { key: 'latvia', code: 'lv', labelId: 'Country.latvia' },
    { key: 'lithuania', code: 'lt', labelId: 'Country.lithuania' },
    { key: 'luxembourg', code: 'lu', labelId: 'Country.luxembourg' },
    { key: 'malta', code: 'mt', labelId: 'Country.malta' },
    { key: 'netherlands', code: 'nl', labelId: 'Country.netherlands' },
    { key: 'poland', code: 'pl', labelId: 'Country.poland' },
    { key: 'portugal', code: 'pt', labelId: 'Country.portugal' },
    { key: 'romania', code: 'ro', labelId: 'Country.romania' },
    { key: 'slovakia', code: 'sk', labelId: 'Country.slovakia' },
    { key: 'slovenia', code: 'si', labelId: 'Country.slovenia' },
    { key: 'spain', code: 'es', labelId: 'Country.spain' },
    { key: 'sweden', code: 'se', labelId: 'Country.sweden' }
  ];
  
  /**
   * Возвращает ISO код страны по её ключу.
   */
  export const getCountryISO = key => {
    const normalizedKey = key?.toLowerCase?.() || key;
    const country = COUNTRY_LIST.find(c => c.key === normalizedKey || c.code === normalizedKey);
    return country ? country.code.toUpperCase() : 'XX';
  };